export { StripCard } from './StripCard';
export type { StripCardProps, StripCardDefaultProps } from './types';
